<template>
	<div class="drawer">
		<el-drawer
		size="433px"
		title="用户信息"
		:visible.sync="drawerStatus"
		@close='close'
		>
			<el-form style="padding:10px 36px 0 0px;">
				<el-form-item label="会员名称：" :label-width="formLabelWidth" prop="nick_name">
					<el-input v-model="form.nick_name" placeholder="请输入顾客昵称" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="性别：" :label-width="formLabelWidth" prop="sex">
					<el-radio-group v-model="form.sex" size="mini">
						<el-radio :label="'男'">男</el-radio>
						<el-radio :label="'女'">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号：" :label-width="formLabelWidth" prop="user_mobile">
					<el-input v-model="form.user_mobile" placeholder="请输入手机号" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="邮箱：" :label-width="formLabelWidth" prop="user_email">
					<el-input v-model="form.user_email" placeholder="请输入邮箱" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="生日：" :label-width="formLabelWidth" prop="sex">
					<el-date-picker style="width:208px;" v-model="datePickerValue" size="mini" :picker-options="{disabledDate(time) {return new Date().getTime() < time.getTime()}}" @change="changeDatePicker" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			
				<el-form-item label="年龄区间" :label-width="formLabelWidth" prop="user_email">
								<el-select v-model="value" placeholder="请选择" @change="age">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
					</el-form-item>
					<el-form-item label="客户来源" :label-width="formLabelWidth" prop="user_source">
								<el-select v-model="user_source" placeholder="请选择" @change="source">
									<el-option v-for="item in option" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
				<el-form-item label="家庭住址：" :label-width="formLabelWidth" prop="user_address">
					<el-input type="textarea" v-model="form.home_address" placeholder="请输入家庭住址" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="紧急联系人：" :label-width="formLabelWidth" >
					<el-input v-model="form.urgent_user" placeholder="请输入紧急联系人" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="紧急电话：" :label-width="formLabelWidth" >
					<el-input v-model="form.urgent_user_mobile" placeholder="请输入紧急电话" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="会员备注：" :label-width="formLabelWidth" >
					<el-input v-model="form.remark" placeholder="请输入备注" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '110px',
				datePickerValue:'',
				ageMonth:'',
				ageYear:'',
				userDetail:{},
				options: [{
          value: '18-25',
          label: '18-25'
        }, {
          value: '25-30',
          label: '25-30'
        }, {
          value: '30-35',
          label: '30-35'
        }, {
          value: '35-40',
          label: '35-40'
        }, {
          value: '45-50',
          label: '45-50'
        }, {
          value: '50-1000',
          label: '50以上'
        }],
		value:'',
		user_source:'',//客户来源
		option: [{
          value: '自然流量',
          label: '自然流量'
        }, {
          value: '宠物广告',
          label: '宠物广告'
        }, {
          value: '抖音',
          label: '抖音'
        }, {
          value: '小红书',
          label: '小红书'
        }, {
          value: '团购',
          label: '团购'
        },{
          value: '官方直播',
          label: '官方直播'
        },{
          value: '其它',
          label: '其它'
        },
	],
				form:{
					"id": '',
					"user_mobile": '',
					"nick_name": '',
					"avatar_pic": '',
					"user_email": '',
					"user_address": '',
					"home_address": '',
					"sex": '',
					birthday: '',
					user_type: '',
					urgent_user: '',
					urgent_user_mobile: '',
					remark:'',
					age_group:[],
					user_source:''
				},
			}
		},
		// computed:{
		// 	userInfo(){
		// 		if(this.$store.state.mendian.userInfo._id){
		// 			return this.$store.state.mendian.userInfo;
		// 		}else{
		// 			return {
		// 				basic_info:{},
		// 				card_info:{},
		// 				company_info:{},
		// 				operation_info:{},
		// 				pets_info:[],
		// 				club_card:{}
		// 			}
		// 		}
		// 	},
		// },
		props:{
			userInfo:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{this.drawerStatus=true})
			this.userDetail = JSON.parse(JSON.stringify(this.userInfo))
			console.log(this.userDetail,"this.userDetail.basic_info");
			if(!this.$public.isNull(this.userDetail.basic_info.birthday)){
				this.datePickerValue = new Date(this.userDetail.basic_info.birthday*1000)
			}
			if(!this.$public.isNull(this.userDetail.basic_info.age_group)){
				this.value = this.userDetail.basic_info.age_group[0]+'-'+this.userDetail.basic_info.age_group[1]
			}
			if(!this.$public.isNull(this.userDetail.basic_info.user_source)){
				this.user_source = this.userDetail.basic_info.user_source
			}
			
			this.changeDatePicker(this.userDetail.basic_info.birthday)
			this.form = {
				"id": this.userDetail._id,
				"user_mobile": this.userDetail.basic_info.user_mobile,
				"nick_name": this.userDetail.basic_info.nick_name,
				"avatar_pic": this.userDetail.basic_info.avatar_pic,
				"user_email": this.userDetail.basic_info.user_email,
				"user_address": this.userDetail.basic_info.user_address,
				"home_address": this.userDetail.basic_info.home_address,
				"sex": this.userDetail.basic_info.sex,
				birthday: '',
				user_type: this.userDetail.basic_info.user_type,
				urgent_user: this.userDetail.basic_info.urgent_user,
				urgent_user_mobile: this.userDetail.basic_info.urgent_user_mobile,
				remark: this.userDetail.basic_info.remark,
				age_group: [],
				user_source:''
				
			}
			console.log(this.form,"this.form");
		},
		methods: {
			close(){
				this.$emit("submit")
			},
			// 切换年龄段
			age(e){
				
		
		},
		source(e){
		
		this.form.user_source=e
		console.log(this.form.user_source,"eeeeeeeee");
	},
			// 保存基本信息
			submit() {
				if(this.$public.isTel(this.form.user_mobile)===false){
					this.$message({
						message: '手机号输入有误',
						type: 'error'
					});
					return 
				}
				if(!this.value){
					this.$message({
						message: '请输入年龄区间',
						type: 'error'
					});
					return 
				}
				let params = {
					"id": this.form.id,
					"user_mobile": this.form.user_mobile,
					"nick_name": this.form.nick_name,
					"avatar_pic": this.form.avatar_pic,
					"user_email": this.form.user_email,
					"user_address": this.form.user_address,
					"home_address": this.form.home_address,
					"sex": this.form.sex,
					birthday: this.$public.FTimeStr10(this.datePickerValue),
					user_type: this.form.user_type,
					urgent_user: this.form.urgent_user,
					urgent_user_mobile: this.form.urgent_user_mobile,
					remark: this.form.remark,
					age_group: this.value.split('-').map(Number),
					user_source:this.form.user_source

				}
				console.log(params.age_group,"/api/Member/Update");
				this.$http.post('/api/Member/Update', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.$emit("submit",true)
					}
				})
			},
			changeAge(){
				let month = parseInt(Number(this.ageYear||0)*12+Number(this.ageMonth||0));
				this.datePickerValue = this.$public.FBirthday(month);
			},
			changeDatePicker(d){
				console.log(d)
				let a = this.$public.FAge(d);
				this.ageYear = a[0];
				this.ageMonth = a[1];
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: $mainColor;
				}
			}
		}
	}
	
</style>
